import { array, struct } from 'io-ts/Decoder';

import { Id as PrincipalId } from '../../../principal/Id';

export const Request = struct({
	principalIds: array(PrincipalId),
});
